import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Switch } from "@mantine/core";
import { IconWand } from "@tabler/icons-react";
import { DEFAULT_ORNAMENT_VARIANT, generateOrnament } from "../api/ornaments";
import type { OrnamentDetail } from "../types/api";
import GenerateForm from "../components/generate/GenerateForm";
import GenerateResult from "../components/generate/GenerateResult";
import OrnamentVariantFields from "../components/generate/OrnamentVariantFields";
import { ornamentPresenter } from "../components/models/presenters";

export default function GenerateOrnamentPage() {
  const { instance } = useMsal();
  const [variant, setVariant] = useState(DEFAULT_ORNAMENT_VARIANT);
  const [forceGenerate, setForceGenerate] = useState(false);
  const [result, setResult] = useState<OrnamentDetail | null>(null);

  return (
    <GenerateForm
      description="Ornaments"
      submitLabel="Generate"
      submitIcon={<IconWand size={16} />}
      busyMessage="Processing… this may take a while"
      onFileChange={() => setResult(null)}
      onSubmit={async (file) => {
        setResult(null);
        setResult(await generateOrnament(instance, file, variant, forceGenerate));
      }}
      result={result && <GenerateResult data={result} presenter={ornamentPresenter} detailPath={`/gallery/ornaments/${result.id}`} />}
    >
      <OrnamentVariantFields value={variant} onChange={setVariant} />
      <Switch
        label="Force generate"
        description="Re-generate even if a result already exists for this image, colour and background choice"
        checked={forceGenerate}
        onChange={(e) => setForceGenerate(e.currentTarget.checked)}
      />
    </GenerateForm>
  );
}
